export const TEAM_MIN_SEATS = 2
export const TEAM_MAX_SEATS = 50

export type Billing = 'monthly' | 'yearly'
